import NewCampaign from '@/models/loyaltyPanel/campaigns/NewCampaign';
import router from '../../../../routes';
import _ from 'lodash';
const getDefaultState = () => ({
  systemNotifications: [],
  campaignTypes: [],
  transactionTypes: [],
  campaignConditions: [],
  products: [],
  campaigns: [],
  oldCampaigns: [],
  coupons: [],
  clientCharacteristics: [],
  newCampaign: new NewCampaign(),
  uploadingImage: null,
  stores: [],
  storesPagination: {},
  productsPagination: {},
  couponsPagination: {},
  campaignsPagination: {},
  couponsTotalPages: null,
  canGoToNextStep: false,
  allRewards: [],
  step: 1,
  allRewardsPagination: {},
  maxStep: 1,
  selectedCampaignsData: [],
  mailData: {},
  notificationVariables: [],
  loyalties: [],
  loyaltiesPagination: {},
});

export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setSystemNotifications(state, payload) {
      state.systemNotifications = payload;
    },
    setSelectedCampaignsData(state, payload) {
      state.selectedCampaignsData = payload;
    },
    setCampaignTypes(state, payload) {
      state.campaignTypes = payload;
    },
    setTransactionTypes(state, payload) {
      state.transactionTypes = payload;
    },
    setCampaignConditions(state, payload) {
      state.campaignConditions = payload;
    },
    setProducts(state, payload) {
      state.products = payload;
    },
    setNewCampaign(state, payload) {
      state.newCampaign = new NewCampaign(payload || {});
      // state.newCampaign = _.isEmpty(payload || {})
      //     ? new NewCampaign()
      //     : payload;
    },
    setCampaigns(state, payload) {
      state.campaigns = payload;
    },
    setOldCampaigns(state, payload) {
      state.oldCampaigns = state.oldCampaigns.concat(payload);
    },
    setCoupons(state, payload) {
      state.coupons = payload;
    },
    setClientCharacteristics(state, payload) {
      state.clientCharacteristics = payload;
    },
    setUploadingImage(state, payload) {
      state.uploadingImage = payload;
    },
    setStores(state, payload) {
      state.stores = payload;
    },
    setStoresPagination(state, payload) {
      state.storesPagination = payload;
    },
    setAllRewardsPagination(state, payload) {
      state.allRewardsPagination = payload;
    },
    setCouponsTotalPages(state, payload) {
      state.couponsTotalPages = payload;
    },
    setProductsPagination(state, payload) {
      state.productsPagination = payload;
    },
    setCouponsPagination(state, payload) {
      state.couponsPagination = payload;
    },
    setCampaignsPagination(state, payload) {
      state.campaignsPagination = payload;
    },
    setCanGoToNextStep(state, payload) {
      state.canGoToNextStep = payload;
    },
    setStep(state, payload) {
      state.step = payload;
    },
    setMaxStep(state, payload) {
      state.maxStep = payload;
    },
    setAllRewards(state, payload) {
      state.allRewards = payload;
    },
    setMailData(state, payload) {
      state.mailData = payload;
    },
    setNotificationVariables(state, payload) {
      state.notificationVariables = payload;
    },
    setLoyalties(state, payload) {
      state.loyalties = payload;
    },
    setLoyaltiesPagination(state, payload) {
      state.loyaltiesPagination = payload;
    },
  },

  actions: {
    async getCampaignSystemNotifications({ commit }) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await NewCampaign.getCampaignSystemNotifications();
        const systemNotifications = data.data;
        commit('setSystemNotifications', systemNotifications);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },
    async getCampaignTypes({ commit }) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await NewCampaign.getCampaignTypes();
        // let array = []
        // for (const key in data.data) {
        //     data.data[key].category = key
        //     array.push(data.data[key])
        //         }
        // const campaignTypes = array;
        const campaignTypes = data.data;
        commit('setCampaignTypes', campaignTypes);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },
    async getTransactionTypes({ commit }) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await NewCampaign.getTransactionTypes();

        commit('setTransactionTypes', data.data);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getProducts({ commit, state }, body) {
      try {
        commit('setLoading', true, { root: true });
        const products = state.products;

        const { data } = await NewCampaign.getProducts(body.query || '');
        let selectedProducts = [];
        let options = state.newCampaign.campaign_type_id_options;

        if (body.page == 1) {
          commit('setProducts', data.data.products);
        } else {
          data.data.products.map((item) => {
            products.push(item);
          });
          commit('setProducts', products);
        }

        commit('setProductsPagination', data.data.pagination);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async getStores({ commit, state }, body) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await NewCampaign.getStores(body.query);

        if (body.page == 1) {
          commit('setStores', data.data.stores);
        } else {
          const stores = state.stores;
          data.data.stores.map((item) => {
            stores.push(item);
          });
          commit('setStores', stores);
        }

        commit('setStoresPagination', data.data.pagination);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async getAllRewards({ commit, state }, body) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await NewCampaign.getAllRewards(body.query);

        if (body.page == 1) {
          commit('setAllRewards', data.data.rewards);
        } else {
          const rewards = state.allRewards;
          data.data.rewards.map((item) => {
            rewards.push(item);
          });
          commit('setAllRewards', rewards);
        }

        commit('setAllRewardsPagination', data.data.pagination);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async getCampaigns({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });
        let query = '?';
        if (body.page) {
          query += `page=${body.page}&`;
        }
        if (body.q) {
          query += `q=${body.q}&`;
        }
        query = query.slice(0, -1);
        const { data } = await NewCampaign.getCampaigns(query);
        const { campaigns, pagination } = data.data;

        commit('setCampaigns', campaigns);
        commit('setCampaignsPagination', pagination);

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response?.data);
      }
    },

    async getOldCampaigns({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });
        let query = '?';
        if (body.page) {
          query += `page=${body.page}&`;
        }
        if (body.q) {
          query += `q=${body.q}&`;
        }
        query = query.slice(0, -1);
        const { data } = await NewCampaign.getCampaigns(query);
        const { campaigns, pagination } = data.data;

        commit('setOldCampaigns', campaigns);
        commit('setCampaignsPagination', pagination);

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response?.data);
      }
    },

    async getCoupons({ commit, state }, body) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await NewCampaign.getCoupons();
        commit('setCoupons', data.data);
        // if(body.page == 1){
        //     commit("setCoupons", data.data.gifts);
        // }else{
        //     const coupons = state.coupons
        //     data.data.gifts.map(item => {
        //         coupons.push(item)
        //     })
        //     commit("setCoupons", coupons);
        // }

        // commit("setCouponsTotalPages", data.data.pagination.total_pages)
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async getClientCharacteristics({ commit }, typeId) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await NewCampaign.getClientCharacteristics(typeId);
        data.data.unshift({
          name: 'No Sub-Condition Needed',
          campaign_client_characteristic_id: null,
          system: 'none',
        });
        commit('setClientCharacteristics', data.data);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response.data);
      }
    },

    async createCampaign({ commit, state }) {
      try {
        commit('setLoading', true, { root: true });

        let newCampaign = { ...state.newCampaign };

        if (newCampaign?.campaign_condition_id_options?.store_participants == '*') {
          newCampaign.campaign_condition_id_options.store_ids = [];
        }

        if (newCampaign.category == 'draw') {
          delete newCampaign.campaign_reward;
          newCampaign.campaign_type_id_options = [];
          delete newCampaign.invoicing_settings;
          // delete newCampaign.override_user_notification_settings
          delete newCampaign.system_notification_ids;
          delete newCampaign.notifier_type;
          // newCampaign.campaign_reward = {}
          // newCampaign.campaign_reward.reward_points = 0
          // newCampaign.invoicing_settings = {
          //     both_percentages: {}
          // };
          // newCampaign.invoicing_settings.company = true;
          // newCampaign.invoicing_settings.store = false;
          // newCampaign.invoicing_settings.both = false;
          // newCampaign.invoicing_settings.both_percentages.company = 0;
        }
        if (
          typeof newCampaign.campaign_client_characteristic_id_options.from_age !== undefined &&
          !newCampaign.campaign_client_characteristic_id_options.from_age
        ) {
          delete newCampaign.campaign_client_characteristic_id_options.from_age;
        }
        if (
          typeof newCampaign.campaign_client_characteristic_id_options.from_age !== undefined &&
          !newCampaign.campaign_client_characteristic_id_options.to_age
        ) {
          delete newCampaign.campaign_client_characteristic_id_options.to_age;
        }

        delete newCampaign.category;
        delete newCampaign.campaign_type_system;

        const { data } = await NewCampaign.create(newCampaign);

        // if(state.uploadingImage){
        //     const id = data.data.campaign.campaign_id;
        //     const fd = new FormData();
        //     fd.append("image", state.uploadingImage);
        //     await NewCampaign.uploadImage(id, fd);
        // }
        if (data.message == 'CAMPAIGN_CREATED') {
          commit('setNewCampaign', new NewCampaign());
          commit('setStep', 1);
          commit('setCanGoToNextStep', false);
          commit('setUploadingImage', null);
          commit('setLoading', false, { root: true });
          commit('setDialog', false, { root: true });
          commit(
            'setNotification',
            {
              show: true,
              type: 'success',
              text: 'You have successfully created campaign!',
            },

            { root: true }
          );

          router.push('/en/loyaltyPanel/campaigns/view-campaigns');
        }
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response.data.message,
          },

          { root: true }
        );
        setTimeout(() => commit('setNotification', '', { root: true }), 5000);
      }
    },

    async uploadFile({ commit }, file) {
      try {
        commit('setLoading', true, { root: true });
        const fd = new FormData();
        fd.append('csv', file);
        const { data } = await NewCampaign.uploadFile(fd);
        commit('setLoading', false, { root: true });
        return data;
      } catch (ex) {
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message,
          },
          { root: true }
        );
        commit('setLoading', false, { root: true });
        console.log(ex.response, 'ex.response');
        return ex.response.data;
      }
    },

    async sendTestMessage({ commit, state }, query) {
      try {
        commit('setLoading', true, { root: true });
        if (state.uploadingImage) {
          const fd = new FormData();
          fd.append('image', state.uploadingImage);
          const imageData = await NewCampaign.uploadTestFile(fd);
          query.image_url = imageData.data.data.image_url;
        }
        let res = await NewCampaign.sendTestMessage(query);
        commit('setLoading', false, { root: true });
        return res;
      } catch (ex) {
        commit('setLoading', false, { root: true });

        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message || 'Error: Test failed',
          },
          { root: true }
        );
        return ex.response || false;
      }
    },

    async getConditions({ commit, state }, id) {
      try {
        commit('setLoading', true, { root: true });
        const { data } = await NewCampaign.getConditions(id);
        let conditions = [...data.data];
        if (state.newCampaign?.campaign_condition_id > 1) {
          let condition =
            (conditions || []).find(
              (x) => x.campaign_condition_id == state.newCampaign.campaign_condition_id
            ) || {};
          condition.options = _.cloneDeep(state.newCampaign.campaign_condition_id_options);
        }

        commit('setCampaignConditions', conditions);

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });

        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message,
          },
          { root: true }
        );
      }
    },

    async uploadImage({ commit, rootState }, { image, type, b64 }) {
      try {
        commit('setLoading', true, { root: true });

        const fd = new FormData();
        fd.append('image', image);

        const { data } = await NewCampaign.uploadImage(fd, type, b64);

        commit('setLoading', false, { root: true });
        commit('setDialog', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'success',
            text: `You have successfully uploaded the image!`,
          },

          { root: true }
        );
        commit('setLoading', false, { root: true });

        return data.data;
      } catch (ex) {
        commit('setLoading', false, { root: true });

        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message,
          },
          { root: true }
        );
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
        commit('setLoading', false, { root: true });

        return false;
      }
    },

    async getNotificationVariables({ commit, state }) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await NewCampaign.getNotificationVariables();
        commit('setNotificationVariables', data?.data?.variables || []);

        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });

        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message,
          },
          { root: true }
        );
      }
    },
    async getLoyalties({ commit, getters, state }, body) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await NewCampaign.getLoyalties(body.query || '');

        if (body.page == 1) {
          commit('setLoyalties', data.data);
        } else {
          const loyalties = state.loyalties;
          data.data.sub_loyalties.map((item) => {
            loyalties.push(item);
          });
          commit('setLoyalties', loyalties);
        }
        if (data.data.pagination) {
          commit('setLoyaltiesPagination', data.data.pagination);
        }
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        console.error(ex.response?.data || ex);
      }
    },

    async sendRewardSmsTest({ commit, state }, query) {
      try {
        commit('setLoading', true, { root: true });

        let res = await NewCampaign.sendRewardSmsTest(query);
        commit('setLoading', false, { root: true });
        return res;
      } catch (ex) {
        commit('setLoading', false, { root: true });

        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data?.message || 'Error: Test failed',
          },
          { root: true }
        );
        return ex.response || false;
      }
    },
  },
};
